<template>
  <div id="liste_commandes">
    <div id="zone_ambassade">
      <b-col cols="12">
        <h2 :class="(showDetails.ambassade ? 'rotate active' : 'no-rotate')">
          Ambassades
          <i
            class="fas fa-chevron-left"
            @click="toggleAmbassades"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col cols="12">
        <GenericTable
          v-show="showDetails.ambassade"
          ref="genericTableAmbassade"
          :name="namespaceAmbassade"
          :actions="actions"
          :colonnes="colsAmbassade"
          :endpoint-url="endpointAmbassade"
          :filterable-col="filterableColAmbassade"
          :extra-filters="extraFiltersAmbassade"
          :display-archive-checkbox="false"
          :no-checkbox="isUserNh ? false : true"
          verbose-namespace="Commande ambassade"
          @row-click="openDetailsAmbassade"
          @action-callback="dispatchAction($event, 'commande_ambassade')"
        />
      </b-col>
    </div>

    <div
      v-if="isUserNh"
      id="zone_libraire"
    >
      <b-col cols="12">
        <h2 :class="showDetails.libraire ? 'rotate active' : 'no-rotate'">
          Libraires
          <i
            class="fas fa-chevron-left"
            @click="toggleLibraires"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col cols="12">
        <GenericTable
          v-show="showDetails.libraire"
          ref="genericTableLibraire"
          :name="namespaceLibraire"
          :actions="actions"
          :colonnes="colsLibraire"
          :endpoint-url="endpointLibraire"
          :filterable-col="filterableColLibraire"
          :display-archive-checkbox="false"
          verbose-namespace="Commande libraire"
          @row-click="openDetailsLibraire"
          @action-callback="dispatchAction($event, 'commande_libraire')"
        />
      </b-col>
    </div>
    <AmbassadeModal :namespace-tab-liste-cmd-ambassade="namespaceAmbassade" />
    <LibraireModal :namespace-tab-liste-cmd-libraire="namespaceLibraire" />
    <ModalExportCommandesFactures />
  </div>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import LibraireModal from "@/components/libraires/LibraireModal.vue";
import AmbassadeModal from "@/components/ambassades/AmbassadeModal.vue";
import ModalExportCommandesFactures from "@/components/commandes/ModalExportCommandesFactures.vue";

import Api from "@/modules/axios";

import { displayErrorSelectOne } from "@/modules/utils";
import { spaceNumber, moneyFilter } from "@/modules/filters";

export default {
  name: "ListeCommandes",
  components: {
    GenericTable,
    LibraireModal,
    AmbassadeModal,
    ModalExportCommandesFactures,
  },
  data() {
    return {
      namespaceAmbassade: "liste_commandes_ambassade",
      namespaceLibraire: "liste_commandes_libraire",
      endpointAmbassade: "/commande_ambassade",
      endpointLibraire: "/commande_libraire",
      colsAmbassade: [
        {
          key: "numero",
          defaultOrder: true,
          sensOrder: "-",
        },
        { key: "devis" },
        { key: "date" },
        { key: "ambassade" },
        { key: "pays__nom", overrideName: "Pays" },
        { key: "date_creation" },
        { key: "user_created" },
        { key: "nb_ouvrages", overrideName: "Nombre d'ouvrage(s)" },
        { key: "prix_total", overrideName: "Montant ($)" },
      ],
      colsLibraire: [
        {
          key: "numero",
          defaultOrder: true,
          sensOrder: "-",
        },
        { key: "pro_forma" },
        { key: "date" },
        { key: "libraire" },
        { key: "pays__nom", overrideName: "Pays" },
        { key: "date_creation" },
        { key: "user_created" },
        { key: "commandes_facture", overrideName: "Facture" },
        { key: "nb_ouvrages", overrideName: "Nombre d'ouvrage(s)" },
        { key: "prix_total", overrideName: "Montant (€)" },
      ],
      filterableColAmbassade: [
        "numero",
        "ambassade__compte",
        "pays__nom",
        { key: "devis__numero", verbose: "devis (numéro)" },
      ],
      filterableColLibraire: [
        "numero",
        "libraire__compte",
        "pays__nom",
        { key: "pro_forma__numero", verbose: "pro forma (numéro)" },
      ],
      showDetails: {
        ambassade: false,
        libraire: false,
      },
      extraFiltersAmbassade: { devis__tenant: this.$store.getters.typeUser.id },
    };
  },
  computed: {
    actions() {
      return this.isUserNh ? [{ title: "Exporter", callback: "export" }] : [];
    },
    isUserNh() {
      return this.$store.getters.typeUser.nom === "NH";
    },
  },
  watch: {
    "$store.getters.typeUser.id": function watchTypeUser() {
      // Actualise la liste si un admin change de tenant
      this.extraFilters = { tenant: this.$store.getters.typeUser.id };
      setTimeout(() => {
        this.$store.dispatch(`${this.$route.name}/fetchData`);
      }, 100);
    },
  },
  mounted() {
    this.$store.commit(
      `${this.namespaceAmbassade}/setFormatDataFunction`,
      this.verboseColsForTable,
    );
    this.$store.commit(
      `${this.namespaceLibraire}/setFormatDataFunction`,
      this.verboseColsForTable,
    );
  },
  methods: {
    /**
     * Affiche/masque le tableau des ambassades et définit le namespace du tableau de recherche.
     * @public
     */
    toggleAmbassades() {
      this.showDetails.ambassade = !this.showDetails.ambassade;
      this.$store.commit("setNamespaceSearch", 0);
    },
    /**
     * Affiche/masque le tableau des libraires et définit le namespace du tableau de recherche.
     * @public
     */
    toggleLibraires() {
      this.showDetails.libraire = !this.showDetails.libraire;
      this.$store.commit("setNamespaceSearch", 1);
    },
    /**
     * Affiche la modale de l'ambassade avec les détails de la commande.
     * @public
     * @param {Object} commande Commande sélectionnée.
     */
    openDetailsAmbassade(commande) {
      this.$modal.show("ambassade", {
        commandeId: commande.id,
        ambassade: commande.ambassade,
      });
    },
    /**
     * Affiche la modale du libraire avec les détails de la commande.
     * @public
     * @param {Object} commande Commande sélectionnée.
     */
    openDetailsLibraire(commande) {
      this.$modal.show("libraire", {
        commandeId: commande.id,
        libraire: commande.libraire,
      });
    },
    // Voir si on garde ou pas
    // dispatchActionAmbassade(actionCode) {
    //   // On execute le dispatch générique qui gére le delete
    //   var resCode = this.$refs.genericTableAmbassade.genericDispatch(
    //     actionCode,
    //     this.namespaceAmbassade,
    //     this.endpoint,
    //     "une commande"
    //   );

    //   if (resCode === -1) {
    //     var checkedRows = this.$store.getters[
    //       `${this.namespaceAmbassade}/rowDisplayed`
    //     ].filter((row) => row._checkBoxChecked);

    //     switch (actionCode) {
    //       case "export":
    //         if (checkedRows.length == 1) {
    //           this.displayModalExport();
    //         } else {
    //           displayErrorSelectOne("une commande");
    //         }
    //         break;

    //       default:
    //         break;
    //     }
    //   }
    // },
    /**
     * Exécute les actions des tableaux des commandes.
     * @public
     * @param {String} actionCode Action sélectionnée.
     * @param {String} type Définit le tableau depuis lequel l'action est effectuée.
     */
    dispatchAction(actionCode, type) {
      let namespace = null;
      let endpoint = null;

      if (type === "commande_ambassade") {
        namespace = this.namespaceAmbassade;
        endpoint = this.endpointAmbassade;
      } else {
        namespace = this.namespaceLibraire;
        endpoint = this.endpointLibraire;
      }

      // On execute le dispatch générique qui gére le delete
      const resCode = this.$refs.genericTableLibraire.genericDispatch(
        actionCode,
        namespace,
        endpoint,
        "une commande",
      );

      if (resCode === -1) {
        const checkedRows = this.$store.getters[
          `${namespace}/rowDisplayed`
        ].filter((row) => row._checkBoxChecked);

        switch (actionCode) {
          case "export":
            if (checkedRows.length === 1) {
              this.displayModalExport(namespace, type);
            } else {
              displayErrorSelectOne("une commande");
            }
            break;

          default:
            break;
        }
      }
    },
    /**
     * Met en forme les données des tableaux des commandes.
     * @public
     * @param {Object} data Données du tableau.
     * @return {Promise}
     */
    verboseColsForTable(data) {
      const { results } = data;

      results.forEach((ligne) => {
        ligne.nb_ouvrages_verbose = spaceNumber(ligne.nb_ouvrages);

        ligne.prix_total_verbose = moneyFilter(ligne.prix_total);
      });

      // Verbose ambassade
      results.forEach((res) => {
        if (res.ambassade) {
          res.ambassade_verbose = res.ambassade.nom;
        } else if (res.libraire) {
          res.libraire_verbose = res.libraire.nom;
        }

        if (res.devis) {
          res.devis_verbose = res.devis.numero;
        } else if (res.pro_forma) {
          res.pro_forma_verbose = res.pro_forma.numero;
        }
      });

      // Verbose de l'user (créé par)
      const usersUpdatedIds = [
        ...new Set(results.map((item) => item.user_created)),
      ];

      const promise = Api()
        .get(`user/?id__in=${usersUpdatedIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabUserUpdated = res.data.results;
          results.forEach((ligne) => {
            ligne.user_created_verbose = (
              tabUserUpdated.find(
                (userUpdated) => ligne.user_created === userUpdated.id,
              ) || {}
            ).username;
          });
          return res;
        });

      return promise;
    },
    /**
     * Affiche la modale d'export.
     * @public
     * @param {String} namespace Namespace du tableau relatif à l'export.
     * @param {String} type Définit si la commande appartient à une ambassade ou à un libraire.
     */
    displayModalExport(namespace, type) {
      const checkedRows = this.$store.getters[`${namespace}/rowDisplayed`].filter(
        (row) => row._checkBoxChecked,
      );

      this.$modal.show("ModalExportCommandesFactures", {
        lignes: checkedRows,
        type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#liste_commandes::v-deep .table-content {
  .numero,
  .devis,
  .pro_forma,
  .facture { width: 150px; }

  .date,
  .date_creation { width: 100px; }

  .ambassade,
  .libraire { width: 200px; }

  .pays__nom { width: 250px; }

  .user_created { min-width: 200px; }

  .commandes_facture { width: 100px; }

  .nb_ouvrages { width: 150px; }

  .prix_total { width: 150px; }
}
</style>
